import React from 'react';
import './About.css';
import AboutBanner from '../../Components/AboutBanner/AboutBanner';
import AboutDescriptions from '../../Components/AboutDescriptions/AboutDescriptions';
import Footer from '../../Components/Footer/Footer';

function About() {
  return (
    <div className="about-page-container">
      <AboutBanner />
      <AboutDescriptions />
      <Footer />
    </div>
  );
}

export default About;
